import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';

const mutationUpdatePermissions = (onSuccess, onError) => {
    return {
        mutationFn: ({ userId, profileUuid, permissions }) => {
            return client.put(
                replaceParameters(USERS.UPDATE_PERMISSIONS.url, { userId: userId }),
                { permissions: permissions, profile: profileUuid }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdatePermissions;